import { render, staticRenderFns } from "./review-failed.vue?vue&type=template&id=a5d299a8&"
import script from "./review-failed.vue?vue&type=script&lang=js&"
export * from "./review-failed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports